<template class="c-ToolPanel">
    <q-card class="c-ToolPanel_1 q-mx-none full-width q-pa-none" style="width: 100%; display: flex; flex-direction: row; max-width: 750px; background-color: white;" v-if="isvisible" flat>
        <q-card class="q-mx-none full-width q-pa-none" style="overflow: auto; width: 100%; flex-grow: 1; display: flex; flex-direction: column; background-color: white;" flat>
            <div v-if="localColumnRules.length > 0">
                <Container @drop="onDropThresholds" drag-handle-selector=".drag-handle" orientation="vertical">
                    <Draggable v-for="(rule,i) in mapped_rules" :key="rule.uid || 'rule-' + i" :index="i">
                        <div class="q-mb-sm">
                            <div class="d-flex-compat align-items-start q-py-sm" style="justify-content: unset; border-top: 1px solid var(--v-lightGreyBorder-base);">
                                <q-icon class="q-mr-sm cursor-move drag-handle" size="sm" name="mdi-drag"></q-icon>
                                <div style="flex-grow: 1;">
                                    <div style="color: var(--v-primaryText-base); font-size: 16px;">{{ rule.Title }}</div>
                                    <div class="text-grey-6 q-mb-xs" style="font-size: 16px;">
                                        <template v-if="rule.value !== undefined">
                                            {{ rule.MetricDisplayValue }}  
                                        </template>
                                    </div>
                                    <template v-if="rule.color">
                                        <div class="color-block" :style="{ backgroundColor: rule.color }"></div>
                                    </template>
                                </div>
                                <div class="d-flex-compat">
                                    <q-icon color="grey" class="q-mr-sm hover-icon" size="sm" :title="Translate('Edit')" @click="editRule(i)" name="mdi-pencil"></q-icon>
                                    <q-icon color="grey" class="hover-icon" size="sm" :title="Translate('Delete')" @click="removeRule(i)" name="mdi-delete"></q-icon>
                                </div>
                            </div>
                        </div>
                    </Draggable>
                </Container>
            </div>
            <div style="justify-content: unset;" class="q-mt-xs">
                <q-btn v-if="!ReadOnly" flat no-caps size="md" color="primary" class="q-px-md q-ma-xs c-SentenceCaseButton"
                       @click="addThreshold">
                    <q-icon name="mdi-plus" size="sm" class="q-mr-xs" />
                    <span>{{ Translate('Add Rule') }}</span>
                </q-btn>
            </div>
        </q-card>
        
        <q-dialog v-model="ruleDialogVisible" persistent>
            <q-card class="threshold-rule-dialog-card">
                <q-card-section class="row items-center no-wrap">
                    <div class="text-h6">
                        {{ dialogMode == "add" ? Translate('New') : Translate('Edit') }} {{ Translate('Rule') }}
                    </div>
                    <q-space></q-space>
                    <q-btn flat round dense icon="mdi-close" @click="ruleDialogVisible = false" />
                </q-card-section>

                <q-card-section >

                    <q-banner
                        v-for="(msg,i) in errorMessages"
                        :key="i"
                        inline-actions
                        class="q-mb-md q-mt-sm q-ml-sm q-mr-sm rounded-borders c-FeedbackBanner"
                        :style="{ backgroundColor: 'color-mix(in srgb, var(--v-error-base) 12%, transparent)', color: 'var(--v-error-base)' }">
                        <template v-slot:avatar>
                            <q-icon name="mdi-alert" size="sm" />
                        </template>
                        <div style="padding: 8px 0; white-space: normal; word-break: break-word;">
                            {{ Translate(msg) }}
                        </div>
                    </q-banner>

                    <div class="q-py-xs">
                        <div class="q-mb-sm">
                            {{ Translate('Apply to') }}
                        </div>                    
                        <div class="d-flex-compat align-center q-mb-md subtitle-1 full-width">
                            <q-select 
                                dense 
                                outlined 
                                hide-bottom-space
                                fill-input
                                use-input
                                hide-selected
                                :input-debounce="0"
                                :label="Translate('Metric')"
                                class="standard-input-field full-width"
                                bg-color="white"
                                style="width: 100%;"
                                
                                :options="chosenMetrics"
                                v-model="newRule.id"
                                option-label="Title" 
                                option-value="ColId"
                                emit-value
                                map-options
                                :readonly="dialogMode == 'edit'"
                                @update:model-value="selectMetricDlg"
                                @filter="filterFn"
                                ></q-select>
                        </div>

                        <div v-if="newRule.id" class="d-flex-compat q-mb-xs subtitle-1">
                            <q-form ref="columnRuleForm" v-model="valid" style="width: 100%;">                 
                                <component ref="columnRuleComponent"
                                    v-bind:is="getColumnComponent(newRule)"
                                    :key="newRule.uid"
                                    :item="getColumn(newRule.id)"
                                    :EventBus="EventBus"
                                    :settings="settings"
                                    :isopen="true"
                                    :isAggregateReport="isAggregateReport"
                                    :aggregateFunction="getaggregateFunction(newRule)"
                                    :initial="getSelectedRule()"
                                    :value="getSelectedRule()"
                                    :advancedSettings="advancedSettings"
                                    @thresholdValuesChanged="thresholdValueChangedHandler"
                                    @thresholdFormatChanged="thresholdFormatChanged">
                                </component>
                            </q-form>
                        </div>
                    </div>
                </q-card-section>

                <q-card-actions>
                    <q-space></q-space>

                    <q-btn color="primary"
                           no-caps
                           class="q-mb-md q-mr-sm c-SentenceCaseButton"
                           :disabled="false" 
                           @click="updateRule()">
                        <span>{{ Translate('Save') }}</span>
                    </q-btn>
                </q-card-actions>
            </q-card>
        </q-dialog>
    </q-card>
</template>

<script>
    /* eslint-disable */

    import { nextTick } from "vue";
    import utils from '@/Shared/utils.jsx';
    import common from './common.js';
    import methods from '@/Shared/methods';

    import { appSettings } from '@/Shared/appSettings';

    import FilterCategory from './filterCategory.vue';
    import MetricTypeFilter from './metricTypeFilterPopup.vue';

    import ThresholdbooleanColumn from './threshold_booleanColumn.vue';
    import ThresholdchannelTypeColumn from './threshold_multiSelectColumn.vue';
    import ThresholdcountColumn from './threshold_durationColumn.vue';
    import ThresholdfloatColumn from './threshold_durationColumn.vue';
    import ThresholdcurrencyColumn from './threshold_durationColumn.vue';
    import ThresholdcustomerIDColumn from './threshold_multiSelectColumn.vue';
    import ThresholddateColumn from './threshold_dateColumn.vue';
    import ThresholddirectionColumn from './threshold_directionColumn.vue';
    import ThresholddurationColumn from './threshold_durationColumn.vue';
    import ThresholdpercentColumn from './threshold_durationColumn.vue';
    import ThresholdphoneNumColumn from './threshold_multiSelectColumn.vue';
    import ThresholdsearchableTextColumn from './threshold_searchableTextColumn.vue';
    import ThresholdtextSetColumn from './threshold_multiSelectColumn.vue';
    import ThresholduserIDColumn from './threshold_multiSelectColumn.vue';

    import { Container, Draggable } from 'vue3-smooth-dnd';

    import Enumerable from "linq";
    import { JsonHubProtocol } from "@microsoft/signalr";

    export default {
        components: {
            Container,
            Draggable,
            FilterCategory,
            MetricTypeFilter,            
	        ThresholdbooleanColumn,
            ThresholdchannelTypeColumn,
            ThresholdcountColumn,
            ThresholdcurrencyColumn,
            ThresholdcustomerIDColumn,
            ThresholdfloatColumn,
            ThresholddateColumn,
            ThresholddirectionColumn,
            ThresholddurationColumn,
            ThresholdpercentColumn,
            ThresholdphoneNumColumn,
            ThresholdsearchableTextColumn,
            ThresholdtextSetColumn,
            ThresholduserIDColumn,
        },
        props: {
            EventBus: null,
            column_list: {
                type: Array
            },
            column_rules: {
                type: Array,
                required: true // Added required for clarity
            },
            initial_column_rules: null,
            ReadOnly: null,
            settings: null,
            report_settings: null,
            report_column_list: null,
            source: null,
            isvisible: null,
            debugMode: null,
            is_detail_report: false,            
        },
        data: function () {
            return {
                localColumnRules: [...this.column_rules], // Initialize with a copy of the prop
                columnLookup: {},
                openpanels: [],
                menuSelectFiltersOpen: false,
                advancedSettings: false,
                dialogMode: null,
                ruleDialogVisible: false,
                selectedRule: {},
                newRule: {
                    id: null,
                    operator: null,
                    value: null,
                    type: null,
                    color: null
                },
                valid: false,
                errorMessages: [],
                filter: '',
            }
        },
        watch: {
            // Watch for changes in the original prop and update the local copy
            column_rules: {
                handler(newVal) {
                    this.localColumnRules = [...newVal];
                },
                deep: true // Watch for nested changes in the array
            },
            advancedSettings: function (newv) {
                appSettings.LocalStorage(this.storageKey + '-thresholds-advancedSettings', newv ? 'true' : null);
            }
        },
        created() {
            if (appSettings.LocalStorage(this.storageKey + '-thresholds-advancedSettings') == 'true')
                this.advancedSettings = true;
            
        },
        mounted() {
            for (let c of this.column_list)
                this.columnLookup[c.ColId] = c;
        },
        computed: {
            isAggregateReport: function() { return !this.is_detail_report },
            mapped_rules: function() {
                // Use localColumnRules instead of column_rules
                var mappedRules = this.localColumnRules.map(c =>  
                {
                    var metricColumn = "";
                    if (c.id.endsWith("_agg"))
                    {
                        metricColumn = this.metricColumns.find(a => a.ColId == c.id);
                        if (!metricColumn)
                        {
                            var lookupKey = c.id.substring(0,c.id.indexOf("_"));
                            if (lookupKey in common.column_lookup)
                            {  
                                var columnDefinition = common.column_lookup[lookupKey];
                                metricColumn = this.metricColumns.find(a => a.ColId == columnDefinition.colId); 
                            }
                        }
                    }
                    else
                    {
                        metricColumn = this.metricColumns.find(a => a.ColId == common.column_lookup[c.id]?.colId); 
                    }
                    let title = "";
                    if (metricColumn)
                    {
                        title = metricColumn.Title;
                    }
                    if (!metricColumn)
                    {                    
                        const segments = c.id.split('_');
                        if (segments.length === 3)
                        {
                            var columnName = segments[0];
                            metricColumn =  common.column_lookup[columnName];
                            if (metricColumn)
                            {
                                let aggFunction = segments[1];
                                switch(aggFunction)
                                {
                                    case "avg":
                                        title =  `${this.Translate('Average')} ${metricColumn.Title}`;
                                        break;
                                    case "max":
                                        title =  `${this.Translate('Longest')} ${metricColumn.Title}`;
                                        break;
                                    case "min":
                                        title =  `${this.Translate('Shortest')} ${metricColumn.Title}`;
                                        break;
                                    case "sum":
                                        title =  `${this.Translate('Total')} ${metricColumn.Title}`;
                                        break;
                                    default:
                                        console.warn(`Unrecognized aggFunction detected: ${aggFunction} for column ${metricColumn.Title}`);
                                        title = metricColumn.Title;
                                        break;
                                }
                                let func = metricColumn.MetricAggs.FunctionList.length > 0 ? metricColumn.MetricAggs.FunctionList[0] : '';
                                title = this.getMetricDisplayName(metricColumn, func);
                            }
                        }
                    }
                    if (!metricColumn)
                    {
                        metricColumn = this.metricColumns.find(a => a.ColId == c.id);
                        title = metricColumn?.Title;
                    } 
                    c.Title = title;
                    
                    // Infer type from column if not set
                    if (!c.type && metricColumn) {
                        const sourceType = metricColumn.SourceType;
                        c.type = sourceType == 'durationColumn' ? 'duration' :
                                 sourceType == 'percentColumn' ? 'percent' :
                                 sourceType == 'currencyColumn' ? 'currency' :
                                 'number';
                    }
                    
                    c.MetricDisplayValue = this.GenerateMetricDisplay(c);
                    return c;    
                });

                return mappedRules;
            },
            metricColumns: function() {
                // These are the fields that are generated by the report - not the source fields.
                // You can filter on either the source fields or the computed metric fields.
                 if (!this.report_column_list && (!this.report_settings || (!this.report_settings.columns && !this.report_settings.metrics))) {
                    return [];
                }
                   
                let cols = [];
                if(this.is_detail_report){
                    if (this.report_column_list)
                    {
                        let visible_columns = this.report_column_list.filter(a => !a.hide);
                        cols = visible_columns.map(item => {
                            const coldef = common.column_lookup[item];
                            return {
                                ColId: coldef.ColId,
                                Title: coldef.Title,
                                SourceType: coldef.SourceType
                                };
                        });
                    }
                    else 
                    {
                        cols = this.report_settings.columns.map(item => {
                            const coldef = common.column_lookup[item.colId];
                            return {
                                    ColId: coldef.ColId,
                                    Title: coldef.Title,
                                    SourceType: coldef.SourceType
                                };
                        });
                    }
                }
                else{
                    cols = this.report_settings.metrics.filter(item => item.colId && common.column_lookup[item.colId]?.MetricAggs.Type != 'placeholder').map(item => {
                        const coldef = common.column_lookup[item.colId];
                        const newtype = common.getAggregateColumnType(item.colId, item.function, coldef.SourceType);
                        return {
                            ColumnUse: { Filter: true },
                            ColId: `${item.colId}_${item.function}_agg`,
                            Title: common.formatHeader({ type: newtype, headerName: coldef.Title, aggFunc: item.function }),
                            SourceType: newtype
                        };
                    });
                    var additionalGroupBy = this.report_settings.groupby.map(item => {
                         const coldef = common.column_lookup[item.colId];
                          return {
                                    ColId: coldef.ColId,
                                    Title: coldef.Title
                                };
                    });
                    cols = [...cols, ...additionalGroupBy];
                }

                return cols.toSorted((a, b) => common.byField(a, b, 'Title'));
            },
            chosenMetrics: function () {
                let filterfunc = null;
                let unsupportedTypes = ["sparklineColumn"];
                if(this.dialogMode == "edit"){
                    filterfunc = (m) => m.ColId == this.newRule.id;
                }else{
                    filterfunc = (m) => !unsupportedTypes.includes(m.SourceType);
                }
                
                let list = this.metricColumns.filter(filterfunc).map(a => ({
                    ColId: a.ColId,
                    Title: a.Title
                }));

                return list.filter(a => !this.filter || a.Title.toLowerCase().includes(this.filter.toLowerCase()));
            },
            showwarn: function () {
                // Use localColumnRules instead of column_rules
                return this.localColumnRules.map(x=> x.id).some(a => a.includes('_agg'));
            },
        },
        methods: {
            ...methods,
            onDropThresholds(result) {
                if (result.removedIndex == null || result.addedIndex == null) {
                    return;
                }
                const item = this.localColumnRules[result.removedIndex];
                this.localColumnRules.splice(result.removedIndex, 1);
                this.localColumnRules.splice(result.addedIndex, 0, item);
                this.$emit('update:column_rules', [...this.localColumnRules]);
            },
            getMetricDisplayName(metric, aggFunc) {
                const col = this.columnLookup[metric.ColId];
                if (col){
                    const formattedMetric = common.formatMetric({ headerName: col.Title, type: col.SourceType, aggFunc: aggFunc });
                    return formattedMetric ? `${metric.Title} (${formattedMetric})` : metric.Title;
                    //return common.formatHeader({ headerName: col.Title, type: col.SourceType, aggFunc: func });
                }else{
                    return metric.Title;
                }
            },
            ConvertDateToDisplayFormat(rawDateString) {
                if (!rawDateString) return "";
                if (this.isDate(rawDateString))
                {
                    return dayjs(rawDateString).format("YYYY-MM-DD hh:mm A"); 
                }
                return this.extractStringFromDateMath(rawDateString);
            }, 
            extractStringFromDateMath(str) { 
                if (typeof str !== 'string' || !str) {
                    return ''; 
                }
                if (str === "now/" || str == "now")
                {
                    return this.Translate("Now");
                }
                
                const match = str.match(/now-(\d+)([dhsmwyM])/); 
                if (!match) {
                    return '';
                }

                const count = parseInt(match[1], 10);
                const unitIndicator = match[2]; 

                const unitMap = {
                    's': 'second',
                    'm': 'minute', 
                    'h': 'hour',
                    'd': 'day',
                    'w': 'week',
                    'M': 'month', 
                    'y': 'year'
                };

                const unitName = unitMap[unitIndicator];
                
                if (!unitName) {
                    return 'Now'; 
                }
                
                const pluralSuffix = count !== 1 ? 's' : '';
                return `${count} ${this.Translate(unitName)}${pluralSuffix} ${this.Translate('ago')}`;
            },
            isDate(str) {
                if (typeof str !== 'string') {
                    return false;
                }
                const date = new Date(str);
                return !isNaN(date.valueOf());
            },
            GenerateMetricDisplay(rule) {
                // Handle "missing" operator for all types
                if (rule.operator == 'missing') {
                    return this.Translate("Missing");
                }
                
                switch(rule.type)
                {
                    case "boolean": {
                        let displayValue = rule.value;
                        if (Array.isArray(displayValue))
                            displayValue = displayValue[0];
                        if (displayValue == null || displayValue === '')
                            return "";
                        return this.Translate(this.ConvertToSentenceCase(String(displayValue)));
                    }
                    case "set":
                    { 
                        let count  = (rule.displayValues && rule.displayValues.length) || 0;
                        if (count == 1)
                        {
                            return `1 ${rule.Title} ${this.Translate('selected')}`;
                        }
                        else 
                        {
                            return `${count} ${rule.Title}s ${this.Translate('selected')}`;
                        }
                    }
                    case "direction": {
                        let displayValue = rule.value;
                        if (Array.isArray(displayValue))
                            displayValue = displayValue[0];
                        if (displayValue == null || displayValue === '')
                            return "";
                        return this.Translate(this.ConvertToSentenceCase(String(displayValue)));
                    }
                    case "searchableText": 
                        return  this.ConvertToSentenceCase(rule.operator) + " " + rule.value;
                    case "text": 
                        return  this.ConvertToSentenceCase(rule.operator) + " " + rule.value;
                    case "date":
                        //var start = dayjs(range.startDate).format("YYYY-MM-DDTHH:mm:ss");
                        if (rule.operator == "inRange")
                        {
                            let fromDisplayDate = this.ConvertDateToDisplayFormat(rule.value);
                            let toDisplayDate = this.ConvertDateToDisplayFormat(rule.valueTo);
                            return this.Translate("Between") + " " + fromDisplayDate + " " + this.Translate("and") + " " + toDisplayDate;
                        }
                        else if (rule.operator == "notInRange")
                        {
                            let fromDisplayDate = this.ConvertDateToDisplayFormat(rule.value);
                            let toDisplayDate = this.ConvertDateToDisplayFormat(rule.valueTo);
                            return this.Translate("Not Between") + " " + fromDisplayDate + " " + this.Translate("and") + " " + toDisplayDate;
                        }
                        else
                        {
                            let fromDisplayDate = this.ConvertDateToDisplayFormat(rule.value);
                             return this.ConvertToSentenceCase(rule.operator) + " " +fromDisplayDate;
                        }           
                    case "duration": 
                        if (rule.operator == "inRange")
                        {
                            return this.Translate("Between") + " " + rule.value + " " + this.Translate("and") + " " + rule.valueTo + " " + this.Translate("Seconds");
                        }
                        else if (rule.operator == "notInRange")
                        {
                            return this.Translate("Not Between") + " " + rule.value + " " + this.Translate("and") + " " + rule.valueTo + " " + this.Translate("Seconds");
                        }
                        else
                        {
                            return this.ConvertToSentenceCase(rule.operator) + " " + rule.value + " " + this.Translate("Seconds");
                        }
                    case "number":
                        if (rule.operator == "inRange")
                        {
                            return this.Translate("Between") + " " + rule.value + " " + this.Translate("and") + " " + rule.valueTo ;
                        }
                        else if (rule.operator == "notInRange")
                        {
                            return this.Translate("Not Between") + " " + rule.value + " " + this.Translate("and") + " " + rule.valueTo ;
                        }
                        else 
                        {
                            return this.ConvertToSentenceCase(rule.operator) + " " + rule.value;
                        }
                    case "percent":
                        const roundPercentDisplay = (v) => (v == null || v === '') ? v : Math.round(Number(v) * 10000) / 100;
                        if (rule.operator == "inRange")
                        {
                            return this.Translate("Between") + " " + roundPercentDisplay(rule.value) + "% " + this.Translate("and") + " " + roundPercentDisplay(rule.valueTo) + "%";
                        }
                        else if (rule.operator == "notInRange")
                        {
                            return this.Translate("Not Between") + " " + roundPercentDisplay(rule.value) + "% " + this.Translate("and") + " " + roundPercentDisplay(rule.valueTo) + "%";
                        }
                        else
                        {
                            return this.ConvertToSentenceCase(rule.operator) + " " + roundPercentDisplay(rule.value) + "%";
                        }
                    case "currency":
                        const currencyCode = appSettings.Currency || 'USD';
                        if (rule.operator == "inRange")
                        {
                            return this.Translate("Between") + " " + rule.value + " " + currencyCode + " " + this.Translate("and") + " " + rule.valueTo + " " + currencyCode;
                        }
                        else if (rule.operator == "notInRange")
                        {
                            return this.Translate("Not Between") + " " + rule.value + " " + currencyCode + " " + this.Translate("and") + " " + rule.valueTo + " " + currencyCode;
                        }
                        else
                        {
                            return this.ConvertToSentenceCase(rule.operator) + " " + rule.value + " " + currencyCode;
                        }
                    default:
                        return this.Translate("Unexpected rule type detected") + " - " + rule.type;
                }
            },
            ConvertToSentenceCase(str) {
                 if (!str) return "";
                str = str.replace(/([a-z])([A-Z])/g, '$1 $2');
                return String(str[0]).toUpperCase() + String(str).slice(1).toLocaleLowerCase();
            },
            removeRule(index) {
                // TODO: confirm delete?
                this.localColumnRules.splice(index,1);
                this.$emit('update:column_rules', [...this.localColumnRules]); // Emit update
            },
            async editRule(index) {
                let rule = this.localColumnRules[index]; // Use localColumnRules
                console.log(`editRule(rule index ${index}:${JSON.stringify(rule)})`);
                this.newRule.id = rule.id;
                this.newRule.operator = rule.operator;
                this.newRule.value = rule.value;
                this.newRule.valueTo = rule.valueTo;
                this.newRule.color = rule.color;
                this.newRule.type = rule.type;
                this.newRule.uid = rule.uid;
                this.newRule.displayValues = rule.displayValues;
                this.selectedRule = {
                    operator: rule.operator,
                    id: rule.id,
                    value: rule.value,
                    valueTo: rule.valueTo,
                    color: rule.color,
                    filter: rule.value,
                    filterTo: rule.valueTo,
                    type: rule.type,
                    displayValues: rule.displayValues,
                    uid: rule.uid
                };
                this.dialogMode = 'edit';
                this.errorMessages = [];
                this.ruleDialogVisible = true;
                console.log(`editRule(rule:${JSON.stringify(rule)})`);         
                console.log(`editRule(selectedRule:${JSON.stringify(this.selectedRule)})`);         
                return rule;
            },
            getMetricSetting(id) {
                // Rule ids are `${colId}_${function}_agg` and BOTH halves can contain
                // underscores (value_count, doc_count, disposition_<guid>), so splitting on '_'
                // cannot recover them. The report settings still hold the real pair.
                if (!id || !id.endsWith("_agg") || !this.report_settings || !this.report_settings.metrics)
                    return null;
                return this.report_settings.metrics.find(m => `${m.colId}_${m.function}_agg` == id) || null;
            },
            getColumn(id) {
                if(!id) return null;
                const metric = this.getMetricSetting(id);
                if (metric && metric.colId in common.column_lookup)
                {
                    return common.column_lookup[metric.colId];
                }
                if (id.indexOf("_") > 0) 
                {
                    var lookupKey = id.substring(0,id.indexOf("_"));
                    if (lookupKey in common.column_lookup)
                    {  
                        return common.column_lookup[id.substring(0,id.indexOf("_"))];
                    }            
                }

                if (id in common.column_lookup)
                {
                    return common.column_lookup[id];            
                }
                console.warn("Could not locate column with id " + id);
                return "";
            },
            getSelectedRule() {
                console.log(`getSelectedRule(rule:${JSON.stringify(this.selectedRule)})`);
                return this.selectedRule;
            },
            isRuleInvalid: function() {
                console.log(`isRuleInvalid ${JSON.stringify(this.newRule)}`);
                if (!this.newRule.id || !this.newRule.color)
                { 
                    return true;
                }
                if (!this.newRule.operator && this.newRule.type != "set" && this.newRule.type != "direction" && this.newRule.type != "boolean" )
                {
                    return true;
                }
                if (((!this.newRule.value && this.newRule.value !== 0) || (Array.isArray(this.newRule.value) && this.newRule.value.length == 0)) && !(this.newRule.operator == 'missing' || this.newRule.operator == 'empty' || this.newRule.operator == 'notEmpty'))
                {
                    return true;
                }
                if ((this.newRule.operator == "inRange" || this.newRule.operator == "notInRange") && ((!this.newRule.valueTo && this.newRule.valueTo !== 0) || (this.newRule.valueTo === this.newRule.value)))
                {
                    return true;
                }
                
                return false;
            },
            getaggregateFunction(rule) {
                if (rule.id.endsWith("_agg"))
                {
                    const metric = this.getMetricSetting(rule.id);
                    if (metric)
                        return metric.function;

                    const parts = rule.id.split('_');
                    if (parts.length > 2)
                    {
                        return parts[parts.length - 2];
                    }                    
                }
                return "";
            },
            getColumnComponent(rule) {
                if (rule.id.endsWith("_agg"))
                {

                    var lookupKey = rule.id.substring(0,rule.id.indexOf("_"));
              
                    if (lookupKey in common.column_lookup)
                    {  
                        var columnDefinition = common.column_lookup[rule.id.substring(0,rule.id.indexOf("_"))];
                        if (columnDefinition.SourceType == "dateColumn")
                        {
                            return "ThresholddateColumn";
                        }
                    }     
                    return 'ThresholddurationColumn';
                }
                else 
                {
                    if(!rule.id) return 'ThresholdtextSetColumn';                
                    var column = this.getColumn(rule.id);                      
                    if(column) {
                        return `Threshold${column.SourceType}`;         
                    }
                }
                return 'ThresholdtextSetColumn';
            },
            addThreshold() {
                this.newRule.uid = utils.generateUUID(); 
                this.newRule.id = null;
                this.newRule.operator = null;
                this.newRule.value = null;
                this.newRule.valueTo = null;
                this.newRule.color = null;
                this.dialogMode = 'add';
                this.ruleDialogVisible = true;
                this.selectedRule = {};
                this.errorMessages = [];
            },
            async updateRule() {
                const columnValid = this.$refs.columnRuleComponent?.validate?.() ?? true;
                const formValid = this.$refs.columnRuleForm
                    ? await this.$refs.columnRuleForm.validate()
                    : true;
                const success = columnValid && formValid;

                this.ruleDialogVisible = !success;
                if (!success) {
                    this.errorMessages = [this.Translate("Please review and complete the highlighted fields.")];
                    return;
                }
                
                this.errorMessages = [];

                let threshold = {
                    id: this.newRule.id,
                    value: this.newRule.value,
                    valueTo: this.newRule.valueTo,
                    values: this.newRule.values,
                    operator: this.newRule.operator,
                    color: this.newRule.color,
                    type: this.newRule.type,
                    displayValues: this.newRule.displayValues,
                    uid: this.newRule.uid ? this.newRule.uid : utils.generateUUID()
                };
                
                let existingRules = this.localColumnRules.filter(a => a.id == this.newRule.id && a.uid == this.newRule.uid); // Use localColumnRules <-- This needs to be based on a unique ID
                if(this.dialogMode == "add" || !existingRules.length) {
                    this.localColumnRules.push(threshold); // Modify local data
                } else {
                    existingRules[0].value = threshold.value;
                    existingRules[0].valueTo = threshold.valueTo;
                    existingRules[0].values = threshold.values;
                    existingRules[0].operator = threshold.operator;
                    existingRules[0].color = threshold.color;
                    existingRules[0].type = threshold.type;
                    existingRules[0].displayValues = threshold.displayValues;
                }
                this.$emit('update:column_rules', [...this.localColumnRules]); // Emit update to parent

                const eventBus = this.EventBus;
                nextTick(() => {
                    eventBus.$emit('SetPanelOpenState', this.newRule.id);
                });
            },
            selectMetricDlg(item) {
                this.newRule.id = item;
                this.newRule.color = null;
                this.newRule.operator = null;
                this.newRule.value = null;
                this.newRule.valueTo = null;
                this.newRule.values = [];
                this.newRule.type = null;
            },
            includes(arr, value) {
                for(let i=0; i<arr.length; i++) {
                    const v = arr[i];
                    if (v === value)
                        return true;
                }

                return false;
            },
            thresholdFormatChanged(message){
                this.newRule.color = message.color;
            },
            thresholdValueChangedHandler(message) {
                console.log("We are inside thresholdValueChangedHandler");
                console.log(`${JSON.stringify(message)}`);
                this.selectedRule = null;
                this.newRule.operator = message.operator;
                this.newRule.value = message.value; 
                this.newRule.valueTo = message.valueTo;
                this.newRule.values = message.values;
                this.newRule.type = message.type;
                this.newRule.displayValues = message.displayValues;   
                this.selectedRule = this.newRule;  
            },
            clearAllThresholds() {
                alert('clearAllThresholds in report filters');
            },
            filterFn(val, update) {
                update(() => {
                    this.filter = val;
                });
            },
        }
    }
</script>

<style scoped>
    .threshold-rule-dialog-card {
        width: 890px;
        max-width: 90vw;
    }

    .columns-three {
        column-count: 3;
    }

    .verydense {
        max-height: 24px;
        min-height: 24px;
    }

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }

    p {
        font-size: 2em;
        text-align: center;
    }

    .dark-grey-flat {
        color:  darkgray;
    }

    .align-items-start {
        align-items: start;
    }

    .d-flex-compat {
        display: flex;
        flex-wrap: nowrap;
    }

    .d-flex-col-compat {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
    }

    .metric_inuse {
        color: cornflowerblue;
    }
    .metric_usedup {
        color: silver;
    }
    .consistentText {
        color: var(--v-black-base) !important; 
        opacity: 0.8 !important; 
        font-size: 14px !important; 
        text-rendering: optimizelegibility !important; 
        letter-spacing:0.1 !important;
    }
    .customHoverButton:before {
        background-color: unset !important;
        transition: unset !important;
    }

    .customHoverButton {
        background-color: unset !important;
        color: var(--v-primary-base);
    }

    .customHoverButton:hover {
        filter: brightness(80%);
    }
    
    .applyToField {
        color: unset !important;
    }

    .cursor-move:hover {
        cursor: move;
    }

    .v-icon::after {
        background-color: transparent;
    }

    .color-block {
        width: 22px; /* Adjust size as needed */
        height: 16px; /* Adjust size as needed */
        border-radius: 2px; /* Make it a circle */
        display: block; /* Aligns with flat */
    }

    .hover-icon {
        color: gray !important; /* Example: Change to blue on hover */
        transition: color 0.3s ease; /* Adds a smooth transition for the color change */
    }

    .hover-icon:hover {
        color: rgba(0,0,0,0.87) !important; /* Example: Change to blue on hover */
        cursor: pointer; /* Indicates it's clickable */
    }
 
</style>